import Bugsnag from '@bugsnag/js'

Bugsnag.start({
        apiKey : "01234567890123456789012345678901",
        endpoints: {
                notify: "/reportJsError",
                sessions: "/reportJsError",
        },
        autoTrackSessions: false,
});

window.Bugsnag = Bugsnag;
